function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Visitors_svg__22_a",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#80DFFD"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#3ABEFA"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "url(#Visitors_svg__22_a)",
  d: "M8 0h34a8 8 0 018 8v34a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8z"
}), React.createElement("path", {
  fill: "#D0F9FE",
  d: "M37 11a4 4 0 014 4v20a4 4 0 01-4 4H13a4 4 0 01-4-4V15a4 4 0 014-4h24zm-.5 7h-23a2.5 2.5 0 00-2.5 2.5v14a2.5 2.5 0 002.5 2.5h23a2.5 2.5 0 002.5-2.5v-14a2.5 2.5 0 00-2.5-2.5zm-23-2a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm4 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM27 27a1 1 0 011 1v6a1 1 0 01-1 1H14a1 1 0 01-1-1v-6a1 1 0 011-1h13zm9 0a1 1 0 011 1v6a1 1 0 01-1 1h-5a1 1 0 01-1-1v-6a1 1 0 011-1h5zm0-7a1 1 0 011 1v3a1 1 0 01-1 1H14a1 1 0 01-1-1v-3a1 1 0 011-1h22zm-14.5-7a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
}));

var SvgVisitors = function SvgVisitors(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

export default SvgVisitors;